const mutations = {
  toggleSidebar(state) {
    state.showSidebar = !state.showSidebar;
    state.minibar = ( state.minibar =='' ? 'mini-sidebar' : '' );
  },
  toggleDropdown(state, index) {
    state.menuItem[index].collapsed = !state.menuItem[index].collapsed;
  },
  fetchProfile(state, index) {
    state.profile = index;
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/sidebar/mutations.js